export default "=== is this a separate article? ===\n\n\n\n";